<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.COUPONS.DETAIL.SHOW"
    :handler="
      (coupon) => {
        this.coupon = coupon;
        $refs.modal.show();
      }
    "
  />

  <DialogComponent ref="modal" type="fullscreen" noInnerPadding hideCloseButton>
    <div class="w-full flex flex-col  h-full p-5 overflow-auto">
      <div class="">
        <FullScreenDialogHeader @backClicked="() => $refs.modal.hide()">
          Coupon
        </FullScreenDialogHeader>
      </div>

      <div class="py-5"></div>
      <!-- Coupon Content -->
      <ImgComponent
        v-if="coupon?.pictureUrl"
        :src="coupon.pictureUrl"
        alt="Coupon"
        class="w-full h-auto rounded-2xl shadow-lg shimmerTarget"
      />

      <!-- Coupon Code Section -->
       <div class="py-8"></div>
      <div
        v-if="coupon?.code"
        class="bg-primary rounded-2xl p-5 shimmerTarget mt-auto sticky bottom-0"
      >
        <div class="text-white text-center mb-3 font-semibold">Code promo</div>
        <div
          class="bg-white rounded-xl p-4 flex items-center justify-between gap-3"
        >
          <div
            class="font-mono text-xl font-bold text-gray-800 truncate flex-1"
          >
            {{ coupon.code }}
          </div>
          <button
            @click="copyCouponCode(coupon.code)"
            class="bg-primary-500 text-white px-4 py-3 rounded-xl font-semibold flex items-center gap-2 whitespace-nowrap"
          >
            <ColorImg
              src="/images/icons/copy.svg"
              alt="Copier"
              class="w-5 h-5"
            />
            Copier
          </button>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import Commons from '@/app/features/shared/libraries/commons';

export default {
  name: 'CouponDetailDialog',

  data() {
    return {
      coupon: null,
      loading: false
    };
  },

  methods: {
    copyCouponCode(code) {
      Commons.copyToClipboard(
        code,
        () => {
          this.$bus.emit(this.$constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Code copié',
            body: code
          });
        },
        () => {
          this.$bus.emit(this.$constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Code non copié',
            body: 'Veuillez réessayer'
          });
        }
      );
    }
  }
};
</script>
